import { useState } from 'react';
import { UserWithRole, Referent, ReferentFunction } from '../../../../shared/services/userService';
import userService from '../../../../shared/services/userService';

export const useReferentsManagement = () => {
  const [referents, setReferents] = useState<Referent[]>([]);
  const [referentFunctions, setReferentFunctions] = useState<ReferentFunction[]>([]);
  const [newReferentFunction, setNewReferentFunction] = useState<string>('');
  const [newReferentDescription, setNewReferentDescription] = useState<string>('');
  const [updating, setUpdating] = useState(false);

  const loadReferents = async (user: UserWithRole) => {
    try {
      const [referentsResponse, functionsResponse] = await Promise.all([
        userService.getUserReferents(user.id),
        userService.getReferentFunctions()
      ]);
      
      if (referentsResponse.success && functionsResponse.success) {
        setReferents(referentsResponse.data);
        setReferentFunctions(functionsResponse.data);
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  };

  const assignReferent = async (userId: number, onSuccess?: (referent: Referent) => void) => {
    if (!newReferentFunction) return;

    try {
      setUpdating(true);
      const response = await userService.assignReferent(
        userId,
        newReferentFunction,
        newReferentDescription || undefined
      );

      if (response.success) {
        const updatedReferents = [...referents];
        const index = updatedReferents.findIndex(r => r.function === newReferentFunction);
        if (index >= 0) {
          updatedReferents[index] = response.data;
        } else {
          updatedReferents.push(response.data);
        }
        setReferents(updatedReferents);
        setNewReferentFunction('');
        setNewReferentDescription('');
        onSuccess?.(response.data);
      }
    } catch (err: any) {
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  const removeReferent = async (userId: number, referentFunction: string) => {
    try {
      setUpdating(true);
      const response = await userService.removeReferent(userId, referentFunction);

      if (response.success) {
        setReferents(referents.filter(r => r.function !== referentFunction));
      }
    } catch (err: any) {
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  const reset = () => {
    setReferents([]);
    setReferentFunctions([]);
    setNewReferentFunction('');
    setNewReferentDescription('');
  };

  return {
    referents,
    referentFunctions,
    newReferentFunction,
    newReferentDescription,
    updating,
    setNewReferentFunction,
    setNewReferentDescription,
    loadReferents,
    assignReferent,
    removeReferent,
    reset,
  };
};

